module.exports = __webpack_public_path__ + "img/5.91e49464.jpg";